/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Category, categories, CategoryType } from '../common/Categories';
import { loadFromLocalStorage } from '../common/localStorage';
import { getUrlByCategory } from '../common/constants';
import { asApplicationJsonBody } from '../common/graphqlJsonBody';

const requestGridDataType = 'REQUEST_GRID_DATA';
const receiveGridDataType = 'RECEIVE_GRID_DATA';
const errorType = 'ERROR_TYPE';
const initialState = {
    gridData: {},
    isLoading: false
}

export const actionCreators = {

    requestGridData: (id: number, queryString: string) => async (dispatch: any, getState: any) => {
        let selectedCategory: Category | undefined = categories.find((category: Category) => {
            return category.id === id;
        });
        selectedCategory = selectedCategory == undefined ? categories[0] : selectedCategory;
        dispatch({ type: requestGridDataType, id, selectedCategory });

        const userId: string = loadFromLocalStorage('AuthToken');
        const encodedToken = 'Basic ' + window.btoa(userId);
        const headerDict: any = {
            'Authorization': encodedToken,
            'Content-Type': 'application/json'
        };
        const url = getUrlByCategory(selectedCategory);
        try {
            if (navigator.onLine) {
                await fetch(url, {
                    headers: new Headers(headerDict),
                    body: asApplicationJsonBody(selectedCategory.requestBodyForGrid.replace('%s', queryString)),
                    method: 'POST'
                }).then(async (response: any) => {
                    const responseData = await response.json();
                    switch (response.status) {
                        case 200:
                            dispatch({ type: receiveGridDataType, selectedCategory, responseData });
                            break;
                        case 400:
                            dispatch({ type: errorType, e: { message: 'Bad Request' } });
                            break;
                        case 500:
                            dispatch({ type: errorType, e: { message: 'Internal server error' } });
                            break;
                        case 401:
                            dispatch({ type: errorType, e: { code: 401, message: responseData.data } });
                            break;
                    }
                    return responseData;
                });
            }
        }
        catch (e) {
            if (navigator.onLine) {
                dispatch({ type: errorType, e });
            }
        }
    }
}

export const reducer = (state: any, action: any) => {
    state = state || initialState;
    switch (action.type) {
        case requestGridDataType:
            return {
                ...state,
                isLoading: true
            };
        case receiveGridDataType:
            switch (action.selectedCategory.id) {
                case 0:
                    return {
                        ...state,
                        gridData: action.responseData.data.myopenservicecases.data,
                        totalCount: action.responseData.data.myopenservicecases.count,
                        isLoading: false,
                        error: undefined,
                        selectedCategory: action.selectedCategory
                    };
                case 1:
                    return {
                        ...state,
                        gridData: action.responseData.data.myclosedservicecases.data,
                        totalCount: action.responseData.data.myclosedservicecases.count,
                        isLoading: false,
                        error: undefined,
                        selectedCategory: action.selectedCategory
                    };
                case 2:
                    return {
                        ...state,
                        gridData: action.responseData.data.mycompanyopenservicecases.data,
                        totalCount: action.responseData.data.mycompanyopenservicecases.count,
                        isLoading: false,
                        error: undefined,
                        selectedCategory: action.selectedCategory
                    };
                case 3:
                    return {
                        ...state,
                        gridData: action.responseData.data.mycompanyclosedservicecases.data,
                        totalCount: action.responseData.data.mycompanyclosedservicecases.count,
                        isLoading: false,
                        error: undefined,
                        selectedCategory: action.selectedCategory
                    };
                case 4:
                    return {
                        ...state,
                        gridData: action.responseData.data.mylicenses.data,
                        totalCount: action.responseData.data.mylicenses.count,
                        isLoading: false,
                        error: undefined,
                        selectedCategory: action.selectedCategory
                    };
                case 5:
                    return {
                        ...state,
                        gridData: action.responseData.data.allservicecases.data,
                        totalCount: action.responseData.data.allservicecases.count,
                        isLoading: false,
                        error: undefined,
                        selectedCategory: action.selectedCategory
                    };
                case 6:
                    return {
                        ...state,
                        gridData: action.responseData.data.allusers.data,
                        totalCount: action.responseData.data.allusers.count,
                        isLoading: false,
                        error: undefined,
                        selectedCategory: action.selectedCategory
                    };
                case 7:
                    return {
                        ...state,
                        gridData: action.responseData.data.allroles.data,
                        totalCount: action.responseData.data.allroles.count,
                        isLoading: false,
                        error: undefined,
                        selectedCategory: action.selectedCategory
                    };
            }
            break;
        case errorType:
            return {
                ...state,
                isLoading: false,
                error: action.e
            };
    }
    return state;
};

